import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbImageContentRowsBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`image-content-rows ${props.attributes.className ? props.attributes.className : ''} ${classes.imageContentRows}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbImageContentRowsBlockFragment = graphql`
  fragment CgbImageContentRowsBlock on WpBlock {
    ... on WpCgbImageContentRowsBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbImageContentRowsBlockPreview = `
    ... on CgbImageContentRowsBlock {
        name
        attributes {
            className
        }
    }
`;